import "./index.scss";

import { Stack } from "@mui/material";
import TitleWithOptions from "components/TitleWithOptions";
import { WorkoutPlan } from "models/workoutplan";

import StrengthDefinedProgram from "./StrengthDefinedProgram";

const StrengthProgramSection = (props: { workoutPlan: WorkoutPlan }) => {
  const { workoutPlan } = props;

  if (workoutPlan.strength_workouts?.length === 0) return null;

  return (
    <section className="strength-program-section">
      <TitleWithOptions title="Strength Program" />
      <p className="subsection-title">Defined Program</p>
      <Stack gap={2}>
        {workoutPlan.strength_workouts.map((m, i) => {
          let tags = [];
          if (m.is_active) tags.push({ text: "Active", type: "green" });
          if (m.is_express) tags.push({ text: "Express", type: "orange" });
          return (
            <StrengthDefinedProgram
              key={`strengthProgram${i}`}
              headerInfo={{
                subtitle: "Exercise",
                tags: tags,
                title: m.name,
              }}
              strengthProgram={m}
              isWorkoutPlanTemplate={workoutPlan.member_id === 0}
            />
          );
        })}
      </Stack>
    </section>
  );
};

export default StrengthProgramSection;
